<div class="modal-header">
  <h3 class="modal-title">{{ title }}</h3>
  <div class="header-actions">
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body">
  <div class="row form-row">
    <div class="col-md-12">
      <label for="name">Name</label>
      <input id="name" type="text" class="form-control" [(ngModel)]="name" placeholder="Enter the name of key" />
    </div>
  </div>
  <div class="row form-row">
    <div class="col-md-12">
      <label for="value">Value</label>
      <input id="value" type="text" class="form-control" [(ngModel)]="value" placeholder="Enter the value of above key" />
    </div>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-primary btn-sm" type="button" (click)="saveSettings()" [disabled]="loading || !name">
    Save Setting
    @if (loading) {
<i class="fa fa-spinner fa-spin"></i>
}
  </button>
  <button class="btn btn-info btn-sm" type="button" (click)="cancel()">Cancel</button>
</div>
